/*****************************************************************************/
/*  File Name: taxCalculations.js                                            */
/*  Date:      June 29, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the bar that will show the users the calculations 
/*             based on tax settings
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

import { useROIContext } from '../../context/roiContext';
import { convertToCurrency } from '../../functions/convertCurrency';
import styles from './styles/roi.module.scss';

function TaxCalculations({ t }) {
  //Load all of the default component varaibles

  const { taxSaving, taxDeduction, capitalPatientsToBreakEven } = useROIContext();

  return (
    <div className={styles.taxCalculations}>
      <div className={styles.taxMetric}>
        <div className={styles.title}>
          Tax Savings from
          <br /> Section 179 Deduction
        </div>
        <div className={styles.value}>
          ${convertToCurrency(taxSaving())}
        </div>
      </div>
      <div className={styles.taxMetric}>
        <div className={styles.title}>
          SYSTEM Costs after
          <br /> 179 Deduction
        </div>
        <div className={styles.value}>
          ${convertToCurrency(taxDeduction())}
        </div>
      </div>
      <div className={styles.taxMetric}>
        <div className={styles.title}>
          # Patients to
          <br /> Break-Even
        </div>
        <div className={styles.value}>
          {capitalPatientsToBreakEven()}
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(TaxCalculations);
